module.exports = __webpack_public_path__ + "static/img/idcard_sl3.5ced6f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/idcard_sl3.png
// module id = UWsk
// module chunks = 1